<template>
  <div>
    <v-data-table
        ref="table"
        v-model="selectedCourse"
        :items="courseGroups"
        :loading="loadingItems"
        :headers="headers"
        hide-default-footer
        loading-text="Buscando..."
        no-data-text="Sem registros"
        class="elevation-0 mytable content-table"
        :show-select="showSelect"
        :single-select="singleSelect"
        style="width: 110%"
    >
      <template v-slot:[`item.when`]="{ item }">
        <div class="py-2">
          <span class="date">{{ parseDate(item.startDate) }} à {{ parseDate(item.endDate) }}</span><br/><br/>
          <span>{{ formatDaysOfTheWeek(item.daysOfTheWeek) }}</span>
        </div>
      </template>

      <template v-slot:[`item.time`]="{ item }">
        <div class="py-2">
          <strong>{{ item.startTime }} às {{ item.endTime }}</strong>
        </div>
      </template>

      <template v-slot:[`item.period`]="{ item }">
        <div class="py-2">
          <strong>{{ formatPeriod(item.period) }}</strong>
        </div>
      </template>

      <template v-slot:[`item.level`]="{ item }">
        <div class="py-2">
          <strong>{{ formatLevel(item.level) }}</strong>
        </div>
      </template>

      <template v-slot:[`item.price`]="{ item }">
        <div class="py-2">
          <strong>{{ formatCurrency(item.course.price) }}</strong>
        </div>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <div class="py-2" v-if="!path.includes('/cursos/checkout/') && !path.includes('/combos/checkout/')">
          <v-btn
              :href="generateLink(item)"
              v-if="item.isThereSlots"
              elevation="0"
              rounded
              class="primary-button"
          >
            Comprar agora
          </v-btn>
          <v-btn
              v-else
              elevation="0"
              rounded
              class="primary-button"
              disabled
          >
            <span style="color: white">Esgotado</span>
          </v-btn>
        </div>
      </template>

      <template v-slot:item.data-table-select="{ on, props, isSelected, item }">
        <v-simple-checkbox
            :ripple="false"
            @click="addCourseGroupId(item)"
            :value="isSelected"
            color="#bc0000"
            v-bind="props"
            v-on="on"
        >
        </v-simple-checkbox>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import FormatDate from "../../../Utils/FormatDate";
import FormatCurrency from "../../../Utils/FormatCurrency";
import FormatParamsUrl from "../../../Utils/FormatParamsUrl";

export default {
  name: "CourseGroup",
  components: {},
  props: {
    course: {type: Object, default: null},
    courseGroups: {type: Array, default: Array},
    showSelect: {type: Boolean, default: false},
    singleSelect: {type: Boolean, default: false},
  },
  async mounted() {
    this.baseUrl = window.location.origin
    this.path = this.$route.path
  },

  data: () => ({
    baseUrl: null,
    path: '',
    loadingItems: false,
    selectedCourse: [],
    headers: [
      {
        text: "Quando?",
        align: "start",
        value: "when",
        sortable: false,
      },
      {
        text: "Horário",
        align: "center",
        value: "time",
        sortable: false,
      },
      {
        text: "Período",
        align: "center",
        value: "period",
        sortable: false,
      },
      {
        text: "Nível",
        align: "center",
        value: "level",
        sortable: false,
      },
      {
        text: "Local",
        align: "center",
        value: "local",
        sortable: false,
      },
      {
        text: "Valores",
        align: "center",
        value: "price",
        sortable: false,
      },
      {
        text: " ",
        value: "actions",
        align: "center",
        sortable: false,
      },
    ],
    periods: [
      {name: "Matutino", value: "0"},
      {name: "Vespertino", value: 1},
      {name: "Noturno", value: 2}
    ],
    levels: [
      {name: "Iniciante", value: "0"},
      {name: "Intermediário", value: 1},
      {name: "Avançado", value: 2}
    ],
    daysOfTheWeek: [
      {name: "Domingo", value: 0},
      {name: "Segunda", value: 1},
      {name: "Terça", value: 2},
      {name: "Quarta", value: 3},
      {name: "Quinta", value: 4},
      {name: "Sexta", value: 5},
      {name: "Sábado", value: 6}
    ],
  }),
  computed: {},
  async created() {
  },
  watch: {},
  methods: {
    getSelectedCourseGroup(){
      return this.selectedCourse
    },

    addCourseGroupId(item) {
      if (this.selectedCourse.length && this.selectedCourse[0].id === item.id) {
        this.selectedCourse = []
        return
      }
      this.selectedCourse = [item]
    },

    parseDate(date) {
      return FormatDate.momentDate(date)
    },

    formatLevel(level) {
      return this.levels.find(x => x.value == level).name;
    },

    formatPeriod(period) {
      return this.periods.find(x => x.value == period).name;
    },

    formatCurrency(value) {
      return FormatCurrency.formatCurrency(value);
    },

    getDaysOfTheWeek(daysOfTheWeek) {
      return this.daysOfTheWeek.filter(x => daysOfTheWeek.includes(x.value)).map(x => x.name).join(', ')
    },

    formatDaysOfTheWeek(daysOfTheWeek) {
      let daysOfTheWeekJson = JSON.parse(daysOfTheWeek)
      if (daysOfTheWeekJson.length === 1) {
        return this.getDaysOfTheWeek(daysOfTheWeekJson)
      }
      daysOfTheWeekJson = daysOfTheWeekJson.sort((x, y) => x - y)
      const isSequential = daysOfTheWeekJson.every((num, i) => i === 0 || num === daysOfTheWeekJson[i - 1] + 1)
      if (isSequential) {
        const [first] = daysOfTheWeekJson
        const last = daysOfTheWeekJson[daysOfTheWeekJson.length - 1]
        return `${this.getDaysOfTheWeek([first])} à ${this.getDaysOfTheWeek([last])}`
      }
      return this.getDaysOfTheWeek(daysOfTheWeekJson)
    },
    generateLink(item) {
      return `${this.baseUrl}/cursos/checkout/${item.course.linkSearch}/${item.id}`
    },
    async goTo(path, id) {
      await this.$router.push({
        path,
        query: {id, curso_combo: 'curso'}
      });
    },
  },
};
</script>
<style scoped>
.date {
  font-weight: 700;
}
</style>